import {
  Box,
  ModalHeader as CModalHeader,
  ModalHeaderProps as CModalHeaderProps,
  Divider,
  Flex,
  FlexProps,
  ModalCloseButton,
} from '@chakra-ui/react';
import React from 'react';

interface ModalHeaderProps extends Omit<CModalHeaderProps, 'title'> {
  containerProps?: FlexProps;
  title?: React.ReactNode;
  withCloseButton?: boolean;
  withDivider?: boolean;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  containerProps = {},
  title,
  withCloseButton = true,
  withDivider = true,
  ...props
}) => (
  <Box marginBottom={{ base: 4 }}>
    <Flex
      alignItems="baseline"
      justifyContent={withCloseButton ? 'space-between' : 'flex-start'}
      whiteSpace="nowrap"
      {...containerProps}
    >
      <CModalHeader {...props}>{title}</CModalHeader>
      {withCloseButton && <ModalCloseButton position="unset" />}
    </Flex>
    {withDivider && <Divider />}
  </Box>
);
